/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verifying_Button_LoadingInputs */

const en_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying...`)
};

const id_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memverifikasi...`)
};

const ms_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang mengesahkan...`)
};

const ca_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificant...`)
};

const cs_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřování…`)
};

const da_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræfter ...`)
};

const de_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verifiziert...`)
};

const et_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollimine...`)
};

const es_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

const fr_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification...`)
};

const hr_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provjera…`)
};

const it_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica in corso...`)
};

const lv_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiek pārbaude...`)
};

const lt_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tikrinama...`)
};

const hu_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellenőrzés...`)
};

const nl_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiëren...`)
};

const nb_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekrefter ...`)
};

const pl_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja…`)
};

const pt_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmando...`)
};

const ro_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se verifică...`)
};

const sk_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overovanie...`)
};

const sl_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preverjanje...`)
};

const fi_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistetaan...`)
};

const sv_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifierar ...`)
};

const vi_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xác minh...`)
};

const tr_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulanıyor...`)
};

const el_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαλήθευση...`)
};

const bg_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потвърждаване...`)
};

const ru_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка...`)
};

const sr_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верификује се...`)
};

const uk_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевірка...`)
};

const ka_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიმდინარეობს დადასტურება...`)
};

const hi_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेरिफाइंग...`)
};

const th_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังตรวจสอบ...`)
};

const ko_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인 중...`)
};

const zh_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在验证...`)
};

const zh_tw_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證中...`)
};

const ja_verifying_button_loading = /** @type {(inputs: Verifying_Button_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認中...`)
};

/**
* | output |
* | --- |
* | "Verifying..." |
*
* @param {Verifying_Button_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verifying_button_loading = /** @type {((inputs?: Verifying_Button_LoadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verifying_Button_LoadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verifying_button_loading(inputs)
	if (locale === "ms") return ms_verifying_button_loading(inputs)
	if (locale === "ca") return ca_verifying_button_loading(inputs)
	if (locale === "cs") return cs_verifying_button_loading(inputs)
	if (locale === "da") return da_verifying_button_loading(inputs)
	if (locale === "de") return de_verifying_button_loading(inputs)
	if (locale === "et") return et_verifying_button_loading(inputs)
	if (locale === "es") return es_verifying_button_loading(inputs)
	if (locale === "fr") return fr_verifying_button_loading(inputs)
	if (locale === "hr") return hr_verifying_button_loading(inputs)
	if (locale === "it") return it_verifying_button_loading(inputs)
	if (locale === "lv") return lv_verifying_button_loading(inputs)
	if (locale === "lt") return lt_verifying_button_loading(inputs)
	if (locale === "hu") return hu_verifying_button_loading(inputs)
	if (locale === "nl") return nl_verifying_button_loading(inputs)
	if (locale === "nb") return nb_verifying_button_loading(inputs)
	if (locale === "pl") return pl_verifying_button_loading(inputs)
	if (locale === "pt") return pt_verifying_button_loading(inputs)
	if (locale === "ro") return ro_verifying_button_loading(inputs)
	if (locale === "sk") return sk_verifying_button_loading(inputs)
	if (locale === "sl") return sl_verifying_button_loading(inputs)
	if (locale === "fi") return fi_verifying_button_loading(inputs)
	if (locale === "sv") return sv_verifying_button_loading(inputs)
	if (locale === "vi") return vi_verifying_button_loading(inputs)
	if (locale === "tr") return tr_verifying_button_loading(inputs)
	if (locale === "el") return el_verifying_button_loading(inputs)
	if (locale === "bg") return bg_verifying_button_loading(inputs)
	if (locale === "ru") return ru_verifying_button_loading(inputs)
	if (locale === "sr") return sr_verifying_button_loading(inputs)
	if (locale === "uk") return uk_verifying_button_loading(inputs)
	if (locale === "ka") return ka_verifying_button_loading(inputs)
	if (locale === "hi") return hi_verifying_button_loading(inputs)
	if (locale === "th") return th_verifying_button_loading(inputs)
	if (locale === "ko") return ko_verifying_button_loading(inputs)
	if (locale === "zh") return zh_verifying_button_loading(inputs)
	if (locale === "zh-tw") return zh_tw_verifying_button_loading(inputs)
	if (locale === "ja") return ja_verifying_button_loading(inputs)
	return en_verifying_button_loading(inputs)
});